<template lang="pug">
div.wrap-module-new-asset.relative.w-full.rounded.overflow-hidden
  div.wrap-header.absolute.w-full.l0.t0
    HeaderModalWindow(label="アセットを追加" @closeModalWindow="$emit('closeModalWindow')")
  div.sub-header.w-full.f.flex-between
    div(v-for="tab in tabs" @click.stop="currentTab = tab.name"
      :class="{'active': tab.name == currentTab}"
      :style="`width: ${100 / tabs.length}%;`"
      :data-tg-tour="tab.tg.tour"
      :data-tg-order="tab.tg.order"
      :data-tg-group="tab.tg.group").tab.f.fh.cursor-pointer
      div.f.fm
        v-icon(size="20" dark
          :color="tab.name == currentTab ? pallete.$active_color : pallete.$dark_primary_text_color").mr4.pt1 {{tab.icon}}
        span.fz14.bold {{tab.label}}
  div(v-show="currentTab == 'search'").search-asset.px10.pt10
    AssetSearcher(v-if="comic && frame && assetType && user"
      @completeSaveAsset="$emit('completeSaveAsset')"
      @addSelectedAsset="addSelectedAsset" @updateAssetIdsToAdd="updateAssetIdsToAdd"
      @toUploadTab="toUploadTab"
      :assetType="assetType" :assetIdsToAdd="assetIdsToAdd"
      :frame="frame" :user="user" :selfRatings="selfRatings")
  div(v-show="currentTab == 'favorite'").new-asset.overflow-scroll.px10.py10
    AssetSelectorByFavorite(v-if="comic && frame && assetType && user"
      @completeSaveAsset="$emit('completeSaveAsset')"
      @addSelectedAsset="addSelectedAsset" @updateAssetIdsToAdd="updateAssetIdsToAdd"
      :assetType="assetType" :assetIdsToAdd="assetIdsToAdd"
      :frame="frame" :user="user" :selfRatings="selfRatings")
  div(v-show="currentTab == 'upload'").new-asset.overflow-scroll.px10.py10
    AssetUploader(v-if="assetType"
      @completeSaveAsset="$emit('completeSaveAsset')" 
      @setParentAsset="setParentAsset"
      :assetType="assetType"
      :parentAsset="parentAsset")
  div(v-if="assetIdsToAdd[0]").f.fh
    div(@click="onAdd").btn-add.absolute.f.fh.py12.cursor-pointer
      span(v-if="!isLoading") {{assetIdsToAdd.length}}件のアセットを追加
      v-progress-circular(v-else size="24" width="3"
        :color="pallete.$dark_primary_text_color" indeterminate)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$modal_header_height: 44px;
$max_new_asset_window_width: 1800px;
.wrap-module-new-asset {
  max-width: 94vw;
  // max-width: $max_new_asset_window_width;
  padding-top: $modal_header_height;
  background: $primary_bg_color;
  .sub-header {
    height: 36px;
    background: $dark_primary_bg_color;
    .tab {
      &.active {
        border-bottom: solid 4px $active_color;
        // border-bottom: solid 2px #fff;
        span {
          color: $active_color;
        }
      }
      span {
        color: $dark_primary_text_color;
      }
    }
  }
  .new-asset, .search-asset {
    min-width: 80vw;
    max-height: 90vh;
  }
  .btn-add {
    margin: 0 auto;
    width: $base_width_percent;
    max-width: $base_max_width_px;
    bottom: 10px;
    border-radius: 3px;
    box-shadow: $box_shadow;
    background: $active_color;
    z-index: 1;
    color: $dark_primary_text_color;
  }
}
</style>

<script>
import '@sjmc11/tourguidejs/src/scss/tour.scss'
import { TourGuideClient } from '@sjmc11/tourguidejs'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import HeaderModalWindow from '@/components/shared/HeaderModalWindow'
import AssetUploader from '@/components/shared/AssetUploader'
import AssetSelectorByFavorite from '@/components/shared/AssetSelectorByFavorite'
import AssetSearcher from '@/components/shared/AssetSearcher'

export default {
  components: {
    HeaderModalWindow, AssetUploader, AssetSelectorByFavorite, AssetSearcher
  },
  props: {
    assetType: {
      type: Object,
      required: null
    },
    tutorial: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      currentTab: 'search',
      tabs: [
        { 
          label: '検索', name: 'search', icon: 'mdi-magnify',
          tg: {}
        },
        // { 
        //   label: 'お気に入り', name: 'favorite', icon: 'mdi-heart'
        // },
        { 
          label: 'お気に入り', name: 'favorite', icon: 'mdi-star',
          tg: {}
        },
        { 
          label: 'アップロード', name: 'upload', icon: 'mdi-file-upload-outline',
          tg: {
            tour: [
              '<p class="mb10">Vroid Studioで作成したオリジナルキャラや、その他3Dモデル・画像などの素材をアップロードすると漫画調に変換され、Comicaroid内で利用することができます。</p>',
              '<p>詳しくは「<a href onclick="window.open(\'https://note.com/comicaroid/n/nd4b866c3cc65\')" target="_blank">Comicaroidでの素材探し・作成に便利なサービス</a>」をぜひ参考にしてみてください！</p>'
            ].join(''),
            order: '1', group: 'create_asset_in_studio'
          }
        },
      ],
      comic: null, frame: null, user: null,
      assetIdsToAdd: [],
      parentAsset: null,
      isLoading: false,
      // tgCreateActor: {
      //   tour: [
      //     '<p>Vroid Studioなどでオリジナルキャラを作成し、Comicaroidにアップロードすることも可能です。</p>',
      //     '<p>詳しくは「<a href="https://note.com/comicaroid/n/nd4b866c3cc65" target="_blank">Comicaroidでの素材探し・作成に便利なサービス</a>」をご覧ください。</p>'
      //   ].join(''),
      //   order: '1', group: 'create_asset_in_studio'
      // },
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    selfRatings () {
      return this.comic && this.comic.selfRatings ? 
        this.comic.selfRatings
        : {
          violenceRepresentation: false,
          sexualRpresentation: false
        }
    }
  },
  async created () {
    const rp = this.$route.params
    this.comic = await database.comicCollection()
      .findById(rp.comicId)
    this.frame = await database
      .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
      .findById(rp.frameId)
    this.user = await database.userCollection().findById(this.uid)
    this.$root.$on('updateFollowingAssets', this.updateFollowingAssets)
    this.$root.$on('updateFavoriteAssets', this.updateFavoriteAssets)
  },
  async mounted () {
    this.startTutorial()
  },
  methods: {
    updateAssetIdsToAdd (assetIdsToAdd) {
      this.assetIdsToAdd = assetIdsToAdd
    },
    updateFavoriteAssets (assetId) {
      if (this.user.favoriteAssets.includes(assetId)) {
        this.user.favoriteAssets = this.user.favoriteAssets
          .filter(f => f !== assetId)
      } else {
        this.user.favoriteAssets = [assetId].concat(this.user.favoriteAssets)
      }
    },
    updateFollowingAssets (assetId) {
      if (this.user.followingAssets.includes(assetId)) {
        this.user.followingAssets = this.user.followingAssets
          .filter(f => f !== assetId)
      } else {
        this.user.followingAssets = [assetId].concat(this.user.followingAssets)
      }
    },
    addSelectedAsset (assetId) {
      const existingAssetIds = this.assetIdsToAdd.filter(a => a === assetId)
      if (existingAssetIds[0]) {
        this.assetIdsToAdd = this.assetIdsToAdd.filter(a => a !== assetId)
      } else {
        this.assetIdsToAdd.push(assetId)
      }
    },
    async onAdd () {
      if (this.isLoading) return
      if (this.$route.name === 'edit-frame') {
        this.isLoading = true

        const rp = this.$route.params

        // 並び順を更新
        // const frameRef = database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
        // let frame = await frameRef.findById(rp.frameId)
        let assetsToAdd = await database.assetCollection()
          .getAssetsByIds(this.assetIdsToAdd)
        // 重複しているアセットを削除
        assetsToAdd = assetsToAdd.filter(a => {
          if (this.frame.assetOrder && this.frame.assetOrder[a.type]) {
            if (this.frame.assetOrder[a.type].includes(a.id)) {
              return false
            }
          }
          return true
        })
        this.assetIdsToAdd = this.assetIdsToAdd.filter(id => {
          return assetsToAdd.map(a => a.id).includes(id)
        })

        for (let i=0; i < this.assetIdsToAdd.length; i++) {
          const asset = assetsToAdd
            .filter(a => a.id === this.assetIdsToAdd[i])[0]
          
          // if (this.frame.assetOrder[asset.type] &&
          //   this.frame.assetOrder[asset.type].includes(this.assetIdsToAdd[i])) {
          //   continue
          // }
          if (!this.frame.assetOrder[asset.type]) this.frame.assetOrder[asset.type] = []
          this.frame.assetOrder[asset.type].unshift(asset.id)

          // this.frame, this.assets, this.episode.assetsを更新する
          this.$root
            .$emit('updateImportedAssetsAfterAddingNewAsset', { 
              frame: this.frame, newAsset: { id: asset.id, ...asset }
            })

          const importObj = {
            assetId: asset.id,
            comicId: rp.comicId,
            episodeId: rp.episodeId,
            pageId: rp.pageId,
            frameId: rp.frameId,
            createdBy: this.uid,
            createdAt: new Date(),
            updatedAt: new Date()
          }
          database.importCollection(asset.id).add(importObj)
        }

        // TO DO: この処理はsaveSceneでスタジオに配置されたアセットに限定して更新した方が正確で効率よくなる
        const episode = await database
          .episodeCollection(rp.comicId)
          .findById(rp.episodeId)
        let asset = episode.asset ? episode.asset : {}
        for (let i=0; i<assetsToAdd.length; i++) {
          if (asset[assetsToAdd[i].type]) {
            if (!asset[assetsToAdd[i].type].includes(assetsToAdd[i].id)) {
              asset[assetsToAdd[i].type].push(assetsToAdd[i].id)
            }
          } else {
            asset[assetsToAdd[i].type] = [assetsToAdd[i].id]
          }
        }
        await database
          .episodeCollection(rp.comicId)
          .update(rp.episodeId, { asset })
        // -----

        await database
          .frameCollection(rp.comicId, rp.episodeId, rp.pageId)
          .update(rp.frameId, { assetOrder: this.frame.assetOrder })

        this.isLoading = false

        this.$emit('completeSaveAsset')
        this.$root.$emit('showNavigationMessage', {
          message: `${this.assetIdsToAdd.length}件のアセットが追加されました`, showOK: true
        })

        this.$emit('startTutorialToCreateObject')
      }
    },
    setParentAsset (asset) {
      this.parentAsset = asset
    },
    async startTutorial () {
      if (!this.tutorial
      || (this.tutorial && !this.tutorial.body.create_asset_in_studio)) {
        await this.sleep(1000)
        const tg = new TourGuideClient({
          finishLabel: 'OK',
          hidePrev: true, showStepDots: false, showStepProgress: false,
          targetPadding: 10,
          dialogZ: 1000
        })
        tg.onFinish(()=>{
          // この処理入れないともう一度チュートリアルを表示できない
          const tgDialog = document.getElementsByClassName('tg-dialog')[0]
          if (tgDialog) tgDialog.remove()
        })
        tg.start('create_asset_in_studio')

        let tutorialObj
        if (this.tutorial) {
          this.tutorial.body.create_asset_in_studio = true
          tutorialObj = this.tutorial
        } else {
          tutorialObj = {
            body: { create_asset_in_studio: true },
            createdAt: new Date(), createdBy: this.uid
          }
        }
        database.userTutorialCollection(this.uid).set('studio', tutorialObj)
      }
    },
    toUploadTab () {
      this.currentTab = 'upload'
    }
  }
}
</script>
